import { faLegacyIconSvg } from 'Shared/faLegacyIcon';
import { MediaItem } from './item';
import { MediaItemImageDisplay } from './item_image';

/**
 * Class MediaItemDocument
 *
 * Represents a MediaItem of type document.
 */
const MediaItemDocument = new Class({
   Extends: MediaItem,

   /**
    * Returns a list of menu functions that should be allowed
    * for this media item in its current state.
    */
   _getMenuOptions: function () {
      return {};
   },

   /**
    * Creates an appropriate representation for the given MediaTarget and
    * passes it as the only argument to the provided callback when it's
    * ready.
    */
   createRepresentationFor: function (mediaTarget, callback) {
      let size = mediaTarget.options.displaySize;
      let self = this;
      self.whenReady(() => {
         let thumb = self.createDisplay(size);
         thumb.whenReady(() => {
            callback(thumb);
         });
      });
   },

   /**
    * Instantiates a MediaItemImageDisplay for this document
    * whose element will automatically update to reflect any state
    * changes in this item.
    */
   createDisplay: function (size) {
      let thumb;
      size = this.getLargestImageSize(size);
      thumb = new MediaItemImageDisplay(this, {
         size: size,
         useBackground: true,
         classOverride: 'mediaDocument',
      });
      return thumb;
   },

   /**
    * Returns the documentid of the document that this mediaItem represents.
    */
   getID: function () {
      return this.data.documentid();
   },

   getFilename: function () {
      return this.data.filename();
   },

   getTitle: function () {
      return this.data.title();
   },

   getType: function () {
      return this.data.type();
   },

   /**
    * Returns the document_type value (e.g. 'word', 'excel', 'powerpoint',
    * 'pdf') used to pick a file-type icon; mirrors getIconName()'s lookup of
    * the same underlying data field.
    */
   getDocumentType: function () {
      return this.data.document_type();
   },

   getFilter: function () {
      return 'onlyDocuments';
   },

   /**
    * Returns the url for this image for the specified size.
    *
    * size: 'thumbnail', 'medium', ...
    */
   getSrc: function (size) {
      return this.data[size]();
   },

   getViewUrl: function () {
      return this.data.view_url();
   },

   getIconName: function () {
      let type = this.getDocumentType();

      // font-awesome only has these filetypes.
      return ['pdf', 'word', 'excel', 'powerpoint'].includes(type)
         ? 'file-' + type + '-o'
         : 'file-o';
   },

   getIconClassname: function () {
      // js implementation of DisplayDocument's getIcon()
      return (
         'pdf-document attachment-icon fa fa-' +
         this.getIconName() +
         ' fa-svg fa-2x officeDocumentIcon document-icon-' +
         this.getDocumentType()
      );
   },

   /**
    * The inner SVG for getIconClassname()'s `fa-svg` element. Callers must
    * render both: the class list alone paints nothing once the webfont goes.
    */
   getIconSvg: function () {
      return faLegacyIconSvg(this.getIconName());
   },

   toWikiText: function () {
      return '[document|' + this.getID() + ']';
   },

   /**
    * Returns the media type and underlying imageid that this mediaItem
    * represents.
    */
   getGlobalID: function () {
      return 'document:' + this.getID();
   },
});

MediaItem.registerType('Document', MediaItemDocument);
